import { DBSchema } from 'idb';

export enum MmDbCollections {
  personalization = 'personalization'
}

export interface MmDbSchema extends DBSchema {
  [MmDbCollections.personalization]: {
    key: string,
    value: any,
  };

}
